export default "__VITE_ASSET__Djk_Y74L__"